@if (saving()) {
  <div class="locker"></div>
}
<div oui-dialog-title>
  <div class="flex-horizontal flex-center width-fill-available">
    <h6>
      @if (data.updateType === 'name') {
        Renommer un document
      }
    </h6>
  </div>
  <div class="content-right width-100-pc">
    <oui-button
      color="secondary"
      type="icon">
      <oui-icon mat-dialog-close>close</oui-icon>
    </oui-button>
  </div>
</div>
<oui-dialog-content>
  <div class="oui-form-line">
    @if (data.updateType === 'name') {
      <oui-textfield
        class="oui-form-field-lg"
        type="text"
        label="Nom du document"
        [control]="fileNameControl">
      </oui-textfield>
    }
  </div>
</oui-dialog-content>
<oui-dialog-actions>
  <oui-button
    type="text"
    oui-dialog-close>
    Annuler
  </oui-button>
  @if (saving()) {
    <oui-dialog-actions>
      <oui-loading
        size="xs"
        class="align-self-center">
      </oui-loading>
    </oui-dialog-actions>
  } @else {
    <oui-button
      type="contained"
      [disabled]="data.updateType === 'name' && !fileNameControl.valid"
      (click)="updateDocument()">
      Valider
    </oui-button>
  }
</oui-dialog-actions>
